import { render, staticRenderFns } from "./addSiteProductDialog.vue?vue&type=template&id=49643dfb&scoped=true"
import script from "./addSiteProductDialog.vue?vue&type=script&lang=js"
export * from "./addSiteProductDialog.vue?vue&type=script&lang=js"
import style0 from "./addSiteProductDialog.vue?vue&type=style&index=0&id=49643dfb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49643dfb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49643dfb')) {
      api.createRecord('49643dfb', component.options)
    } else {
      api.reload('49643dfb', component.options)
    }
    module.hot.accept("./addSiteProductDialog.vue?vue&type=template&id=49643dfb&scoped=true", function () {
      api.rerender('49643dfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/stockPage/addProductDialog/addSiteProductDialog.vue"
export default component.exports